@if (showStorybook$ | async) {
  <bb-showcase-storybook></bb-showcase-storybook>
} @else {
  <bb-heading-container></bb-heading-container>
  <bb-showcase-ui [componentId]="componentId" [scssTokensHtml]="scssTokensDoc$ | async"></bb-showcase-ui>
}
